import React from "react";
import SearchResultCard from "./SearchCard";

interface SearchResult {
  title?: string;
  content?: string;
  date?: string;
  source?: string;
  relevance?: number;
  url?: string;
  summary?: string;
}

interface SearchResultsProps {
  results: SearchResult[];
  isLoading?: boolean;
  isNewsletterMode?: boolean;
}

const SearchResults: React.FC<SearchResultsProps> = ({
  results,
  isLoading,
}) => {
  console.log("isLoading", isLoading);
  return (
    <div className="space-y-8">
      {isLoading ? (
        <div className="w-full text-center py-4 min-h-[200px] flex items-center justify-center">
          Loading results...
        </div>
      ) : !results?.length ? (
        <div className="w-full text-center py-4 text-gray-500 min-h-[200px] flex items-center justify-center">
          No results found
        </div>
      ) : (
        <div className="w-full space-y-4">
          {results.map((result, index) => (
            <SearchResultCard key={`search-result-${index}`} result={result} />
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchResults;
